import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';


@Component({
  templateUrl: 'ok-dialog.component.html',
  host: {'class': 'ok-dialog'},
  styleUrls: ['ok-dialog.component.scss']
})
export class OkDialogComponent {

  message:string = null;
  html:string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
  ) {

    this.message = _.get(data, 'message', null);
    this.html = _.get(data, 'html', null);

  }






}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/components/ok-dialog/ok-dialog.component.ts